import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { MailCenterNotification } from '../models/notifications/mail-center-notification.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class MailCenterApiService extends ApiService
{

    constructor(protected http: HttpClient, protected apiUrlService: ApiUrlService, protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    getRecentMessages(accountId: number, locationId: number, lastMessageId: string = null): Observable<MailCenterNotification[]>
    {
        return this.apiRequest(this.apiUrlService.getRecentMessagesUrl(accountId, locationId, lastMessageId), this.HttpMethod.Get);
    }

    markMessagesAsRead(accountId: number, messageIds: string[]): Observable<any>
    {
        const messageIdsString = this.createMessageIdsStringFromArray(messageIds);
        return this.apiRequest(this.apiUrlService.getMarkMessagesAsReadUrl(accountId, messageIdsString), this.HttpMethod.Post);
    }

    deleteMessages(accountId: number, messageIds: string[]): Observable<any>
    {
        const messageIdsString = this.createMessageIdsStringFromArray(messageIds);
        return this.apiRequest(this.apiUrlService.getDeleteMessages(accountId, messageIdsString), this.HttpMethod.Post);
    }

    private createMessageIdsStringFromArray(messageIds: string[]): string
    {
        let messageIdsString = 'messageIds=';

        messageIds.forEach(messageId =>
        {
            messageIdsString += messageId + ';';
        });

        return messageIdsString;
    }
}
